import React from "react";

const ChecklistDisclaimer = () => (
  <footer>
    <p>
      <i>
        By submitting this form, you agree to receive content related to advertising opportunities from Today's Clinical
        Lab. A sales representative from Today's Clinical Lab may contact you to offer content or products tailored to
        your interests. You can opt-out at any time.
      </i>
    </p>
  </footer>
);

export default ChecklistDisclaimer;
